import Switch from '@tencent/dui/lib/components/Switch';
import React, { Component } from 'react';
import styles from './form-accordion.less.js';

class FormAccordion extends Component {
    constructor(props) {
        super(props);
        this.id = Math.random().toString(36)
            .substr(2, 6);
        this.clickIcon = () => {
            var _a, _b;
            if (!this.props.showSwitch) {
                return;
            }
            this.setState({
                checked: !this.state.checked,
            });
            (_b = (_a = this.props).onCollapse) === null || _b === void 0 ? void 0 : _b.call(_a, !this.state.checked);
        };
        this.state = {
            checked: !!(!this.props.collapsable || this.props.defaultOpen),
        };
    }
    render() {
        const titleless = !this.props.title;
        const classes = [styles.accordion];
        if (titleless) {
            classes.push(styles['accordion-titleless']);
        }
        return React.createElement("div", { className: classes.join(' '), style: this.props.style },
            this.renderInput(),
            !titleless && React.createElement("label", { className: styles['accordion-header'], htmlFor: this.id, role: "tab", onClick: this.clickIcon },
                this.props.icon && React.createElement("i", { className: styles.icon }, this.props.icon),
                this.props.title,
                React.createElement("div", { className: styles.action, onClick: e => e.preventDefault() }, this.props.showSwitch
                    ? React.createElement(Switch, { disabled: !this.props.collapsable, checked: this.state.checked, onChange: (checked) => {
                            var _a, _b;
                            this.setState({
                                checked,
                            });
                            (_b = (_a = this.props).onCollapse) === null || _b === void 0 ? void 0 : _b.call(_a, checked);
                        } })
                    : this.props.action)),
            React.createElement("div", { className: styles['accordion-body'], onMouseDown: e => e.preventDefault() }, this.props.children));
    }
    renderInput() {
        const { showSwitch, } = this.props;
        const titleless = !this.props.title;
        if (titleless) {
            return null;
        }
        if (showSwitch) {
            return React.createElement("input", { type: "checkbox", id: this.id, name: this.props.name, hidden: true, disabled: !this.props.collapsable, checked: this.state.checked, onChange: (e) => {
                    var _a, _b;
                    this.setState({
                        checked: !e.target.checked,
                    });
                    (_b = (_a = this.props).onCollapse) === null || _b === void 0 ? void 0 : _b.call(_a, !e.target.checked);
                } });
        }
        return React.createElement("input", { type: "checkbox", id: this.id, name: this.props.name, hidden: true, disabled: !this.props.collapsable, defaultChecked: !this.props.collapsable || this.props.defaultOpen, onChange: (e) => {
                var _a, _b;
                (_b = (_a = this.props).onCollapse) === null || _b === void 0 ? void 0 : _b.call(_a, !e.target.checked);
            } });
    }
}

export { FormAccordion };
//# sourceMappingURL=form-accordion.js.map
